import React from 'react';

var SvgFinanceFilledIcon = function SvgFinanceFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m15.066 7.322-.808-2.25-.417-.999c-.45-1.077-1.651-1.63-2.763-1.274l-4.76 1.527c-1.25.401-1.892 1.784-1.393 2.998-.964.254-1.675 1.132-1.675 2.176v5c0 1.243 1.007 2.25 2.25 2.25h9c1.243 0 2.25-1.007 2.25-2.25v-5c0-1.047-.715-1.927-1.684-2.178Zm-8.754-.568c-.166-.405.048-.866.465-1l4.759-1.526c.37-.12.77.065.921.424l.094.225-6.198 1.976-.04-.099Zm7.135.496-.35-.973-3.052.973h3.402Z"
  }));
};
SvgFinanceFilledIcon.displayName = "FinanceFilledIcon";

export { SvgFinanceFilledIcon as S };
